import { render } from "./ErrorDialog.vue?vue&type=template&id=183d5e66"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__